import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect } from "react"
import axios from "axios"
import { useAPIBase } from "../../../util"

export default function OtpRoute() {
  const apiBase = useAPIBase()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      console.log(searchParams)
      console.log(searchParams.get("code"))
      const otp = searchParams.get("code")
      const email = searchParams.get("email")
      const response = await axios.get(
        apiBase(`get_token?otp=${otp}&email=${email}`).toString()
      )
      const token = response.data.access_token
      localStorage.setItem("token", token)
    }

    fetchData()
    navigate("/device")
  }, [searchParams])

  return null
}
